import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/modern/applications/widget-next/src/app/global-error.tsx");
